import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VentanillaRoutingModule } from './ventanilla-routing.module';
import { ListadoPresolicitudesComponent } from './listado-presolicitudes/listado-presolicitudes.component';
import { MatCardModule } from '@angular/material/card';
import { BuscarUpaegComponent } from './buscar-upaeg/buscar-upaeg.component';
import { MatButtonModule, MatCheckboxModule, MatDialogModule, MatExpansionModule, MatFormFieldModule, MatInputModule, MatRadioModule, MatSelectModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopApoyosComponent } from './components/pop-apoyos/pop-apoyos.component';


@NgModule({
  declarations: [ListadoPresolicitudesComponent, BuscarUpaegComponent, PopApoyosComponent],
  imports: [
    CommonModule,
    VentanillaRoutingModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatExpansionModule,
  ],
  entryComponents: [
    PopApoyosComponent
  ]
})
export class VentanillaModule { }
